<div class="container mt-5">
  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiError}}
  </div>
  }
  <div class="nav2"><a routerLink="/jobs/30" placement="start" ngbTooltip="Bin">Bin</a></div>
  <div class="nav"><a routerLink="/geometry/0" placement="start" ngbTooltip="Create a new job">+</a></div>

  <mat-form-field>
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
      <td mat-cell *matCellDef="let element"><a routerLink="/geometry/{{element.id}}">{{element.id}}</a></td>
    </ng-container>

    <ng-container matColumnDef="creation_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
      <td mat-cell *matCellDef="let element"> {{element.creation_date | date:'HH:mm, dd MMM yyyy' }} </td>
    </ng-container>

    <ng-container matColumnDef="initiator">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>By</th>
      <td mat-cell *matCellDef="let element"> {{element.initiator}} </td>
    </ng-container>

    <ng-container matColumnDef="org">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>For</th>
      <td mat-cell *matCellDef="let element"> {{element.org}} </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
      <td mat-cell *matCellDef="let element"> {{element.title}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let element">{{this.helpers.getJobTypeString(element.type)}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">{{this.helpers.getJobStatusString(element.status)}} </td>
    </ng-container>

    <ng-container matColumnDef="percentage_complete">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>%</th>
      <td mat-cell *matCellDef="let element"> <mat-progress-bar mode="determinate"
          value="{{element.percentage_complete}}"></mat-progress-bar> </td>
    </ng-container>

    <ng-container matColumnDef="cpu_seconds">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CPU</th>
      <td mat-cell *matCellDef="let element"> {{element.cpu_seconds}} </td>
    </ng-container>

    <ng-container matColumnDef="node_id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Node</th>
      <td mat-cell *matCellDef="let element"> {{element.node_id}} </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element"> <a [hidden]="element.is_deleted" href="javascript:void(0)"
          (click)="copyJob(element.id)">Copy&nbsp;</a>
        <a [hidden]="element.is_deleted || ![0, 10, 70, 80].includes(element.status)" href="javascript:void(0)"
          (click)="deleteJob(element.id, 0)">Bin&nbsp;</a>
        <a [hidden]="![0, 80].includes(element.status)|| element.is_deleted" href="javascript:void(0)"
          (click)="queueJob(element.id)">Queue</a>
        <a [hidden]="!element.is_deleted" href="javascript:void(0)"
          (click)="deleteJob(element.id, 20)">Restore&nbsp;</a>
        <a [hidden]="!element.is_deleted" href="javascript:void(0)" (click)="deleteJob(element.id, 10)">Delete&nbsp;</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of jobs">
  </mat-paginator>


</div>